import { ISectionLabel } from '../../../interfaces/scheduler_interfaces';

import * as _4 from 'lodash4';
export class SectionLabel {
  static build(sectionLabel: ISectionLabel) {
    return new SectionLabel(sectionLabel);
  }
  id: -1;
  value: string;
  desc: string;

  constructor(sectionLabel: ISectionLabel) {
    _4.merge(this, sectionLabel);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/section_labels_builder.ts